import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserTabMenuComponent } from '../../layout/user-tab-menu/user-tab-menu.component';
import { NavigatieVoorkeurService } from '../../services/navigatie-voorkeur.service';

@Component({
	selector: 'app-rollen',
	templateUrl: './rollen.component.html',
	styleUrls: ['./rollen.component.scss'],
	imports: [UserTabMenuComponent, RouterOutlet],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RollenComponent {
	protected readonly navigatieVoorkeurService = inject(NavigatieVoorkeurService);
}
